import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function BetaBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('bs_beta_banner');
    if (!dismissed) setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem('bs_beta_banner', 'dismissed');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="bg-amber-50 border-b border-amber-200 px-4 py-2.5"
      data-testid="beta-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-amber-800">
          <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0" />
          <span>
            <strong>Beta Service</strong> — Outputs are assistive and provided as-is. Users remain responsible for commercial decisions.
          </span>
        </div>
        <button
          onClick={dismiss}
          className="text-amber-500 hover:text-amber-700 transition-colors shrink-0"
          aria-label="Dismiss"
          data-testid="beta-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
